export function localDate(date = new Date()) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
}
export function lineQuantity(line, garmentQuantity) {
  return Number(line.quantity_per_unit || 0) * Number(garmentQuantity || 0) * (line.line_type === "material" ? 1 + Number(line.waste_pct || 0) / 100 : 1);
}
